import { MailColorDefinitions, type ColorDefinitions } from '@adornis/buchungsheld-db/entities/ColorDefinitions.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter } from 'rxjs';

@customElement('bh-color-definitions-editor')
export class BHColorDefinitionsEditor extends FormField<ColorDefinitions> {
  @state() private readonly _form = new FormController(this, this.value.observable.pipe(filter(Boolean)));

  @state() private readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  override render() {
    const translate = (key: string) => this._translation.translate('COLOR_EDITOR', key as any) as string;
    return html`
      <tr-flex space="md">
        <tr-text> ${this._translation.translate('COLOR_EDITOR', 'REGISTRATION_FORM')} </tr-text>
        <tr-grid columns="1fr 1fr max-content" space="md">
          ${this._renderColorRow('registrationColorDefinitions', translate('stepColor'), 'stepColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('stepFontColor'), 'stepFontColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('productColor'), 'productColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('productFontColor'), 'productFontColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('moreProductsColor'), 'moreProductsColor')}
          ${this._renderColorRow(
            'registrationColorDefinitions',
            translate('moreProductsFontColor'),
            'moreProductsFontColor',
          )}
          ${this._renderColorRow('registrationColorDefinitions', translate('chipInfosColor'), 'chipInfosColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('chipInfosFontColor'), 'chipInfosFontColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('oldPriceColor'), 'oldPriceColor')}
          ${this._renderColorRow('registrationColorDefinitions', translate('newPriceColor'), 'newPriceColor')}
          ${this._renderColorRow(
            'registrationColorDefinitions',
            translate('layoutLightContrastColor'),
            'layoutLightContrastColor',
          )}
          ${this._renderColorRow('registrationColorDefinitions', translate('warnColor'), 'warnColor')}
        </tr-grid>

        <tr-text> ${this._translation.translate('COLOR_EDITOR', 'MAILS')} </tr-text>
        <tr-grid columns="1fr 1fr max-content" space="md">
          ${this._renderColorRow('mailColorDefinitions', translate('accentColor'), 'accentColor')}
        </tr-grid>
      </tr-flex>
    `;
  }

  private _renderColorRow(group: string, description: string, key: string) {
    if (!this.value.value) return;

    // set default value for mails
    if (!this.value.value[group]) {
      if (group === 'mailColorDefinitions') {
        this.value.value[group] = new MailColorDefinitions({});
      }
    }

    const value = this.value.value[group]?.[key];

    if (value)
      return html`
        <tr-flex center crossaxis-center>
          <tr-text ${css({ textAlign: 'center' })}> ${description} </tr-text>
        </tr-flex>
        <tr-input type="color" ${this._form.field(group, key)}></tr-input>
        <tr-flex center crossaxis-center>
          <tr-icon
            big
            pointer
            @click=${() => {
              if (!this.value.value) return;
              this.value.value[group][key] = '';
              this.requestUpdate();
            }}
          >
            delete
          </tr-icon>
        </tr-flex>
      `;

    return html`
      <tr-flex center crossaxis-center>
        <tr-text ${css({ textAlign: 'center' })}> ${description} </tr-text>
      </tr-flex>
      <tr-flex center crossaxis-center>
        <tr-text> ${this._translation.translate('COLOR_EDITOR', 'notDefined')} </tr-text>
      </tr-flex>
      <tr-flex center crossaxis-center>
        <tr-icon
          big
          pointer
          @click=${() => {
            if (!this.value.value) return;
            this.value.value[group][key] = '#000';
            this.requestUpdate();
          }}
        >
          add
        </tr-icon>
      </tr-flex>
    `;
  }
}
